import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";

const USER_INFO = 'info/user';
const EMAIL = '/email';
const PASS = '/password';

export default {
    methods: {
        async getUserInfo() {
                const url = `${baseURL}${USER_INFO}`
                const response = await this.httpSession().get(url)
                console.debug('[USER_INFO][getUserInfo] RESPONSE', response.data)
                return response.data;
        },
        async changeEmail(email) {
                const url = `${baseURL}${USER_INFO}${EMAIL}`
                const response = await this.httpSession().put(url, {email})
                return response.data
        },
        async changePassword(password) {
                const url = `${baseURL}${USER_INFO}${PASS}`
                const response = await this.httpSession().put(url, {newPassword: password})
                return response.data
        }
    },
    mixins: [SessionApi],
};
